/**
 * Hyperlink scheme allow-list for rendering TipTap link marks (ADR-037).
 *
 * The client twin of `server/src/lib/compliance/safeHref.ts`. SOP / lesson
 * content can be imported from untrusted `.docx` files, so a link mark's href
 * may be `javascript:…` / `data:…`. React does NOT strip those, so the shared
 * renderer must refuse to emit a live `<a>` for any non-allow-listed scheme —
 * neutralizing both freshly-imported and already-stored malicious hrefs on
 * read. The original href is emitted only when this test passes.
 */
export function isSafeHref(raw: string): boolean {
  // Drop ASCII control chars (0x00–0x1F), space (0x20), and DEL (0x7F) — what a
  // browser's URL parser ignores — then case-fold. Code-point filter (not a
  // control-char regex) to stay lint-clean.
  let normalized = '';
  for (const ch of raw) {
    const code = ch.codePointAt(0) ?? 0;
    if (code > 0x20 && code !== 0x7f) normalized += ch;
  }
  normalized = normalized.toLowerCase();
  if (normalized.length === 0) return false;
  if (
    normalized.startsWith('#') ||
    normalized.startsWith('/') ||
    normalized.startsWith('./') ||
    normalized.startsWith('../')
  ) {
    return true;
  }
  return /^(?:https?:|mailto:|tel:)/.test(normalized);
}
